import { createFileRoute } from '@tanstack/react-router';

import { StudentPoliciesPage } from '~features/students/index';

const Component = () => {
  const { studentId } = Route.useParams();
  return <StudentPoliciesPage studentId={studentId} />;
};

export const Route = createFileRoute('/_auth/_layout/students/$studentId/policies')({
  component: Component,
});
